import { render, staticRenderFns } from "./cartItem.vue?vue&type=template&id=5160b6bb&scoped=true&lang=pug&"
import script from "./cartItem.vue?vue&type=script&lang=js&"
export * from "./cartItem.vue?vue&type=script&lang=js&"
import style0 from "./cartItem.vue?vue&type=style&index=0&id=5160b6bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160b6bb",
  null
  
)

export default component.exports